import {
  SCALE_3_POINT,
  SCALE_3_POINT_0_LABEL,
  SCALE_3_POINT_1_LABEL,
  SCALE_3_POINT_2_LABEL,
  SCALE_3_POINT_ME_POINTS,
  SCALE_3_POINT_NM_POINTS,
  SCALE_3_POINT_PM_POINTS,
  SCALE_4_POINT,
  SCALE_4_POINT_1_LABEL,
  SCALE_4_POINT_2_LABEL,
  SCALE_4_POINT_EE_POINTS,
  SCALE_4_POINT_ME_POINTS,
  SCALE_4_POINT_NI_POINTS,
  SCALE_4_POINT_NM_POINTS,
  SCALE_4_POINT__1_LABEL,
  SCALE_4_POINT__2_LABEL,
  SCALE_5_POINT,
  SCALE_5_POINT_0_LABEL,
  SCALE_5_POINT_1_LABEL,
  SCALE_5_POINT_2_LABEL,
  SCALE_5_POINT_3_LABEL,
  SCALE_5_POINT_4_LABEL,
  SCALE_5_POINT_AE_POINTS,
  SCALE_5_POINT_EE_POINTS,
  SCALE_5_POINT_ME_POINTS,
  SCALE_5_POINT_NI_POINTS,
  SCALE_5_POINT_NM_POINTS,
  SCALE_BINARY,
  SCALE_BINARY_MET_LABEL,
  SCALE_BINARY_ME_POINTS,
  SCALE_BINARY_NM_POINTS,
  SCALE_BINARY_NOT_MET_LABEL,
  SCALE_SCORE_MAPPING,
  type ScorecardScale,
} from '@hap/constants'

export function getCriterionPoints(scale: ScorecardScale): {
  minPossible: number
  maxPossible: number
} {
  switch (scale) {
    case SCALE_BINARY:
      return { minPossible: 0, maxPossible: 1 }
    case SCALE_3_POINT:
      return { minPossible: 0, maxPossible: 2 }
    case SCALE_4_POINT:
      return { minPossible: 0, maxPossible: 3 }
    case SCALE_5_POINT:
      return { minPossible: 0, maxPossible: 4 }
    default:
      throw new Error(`unsupported scale ${scale}`)
  }
}

export function getCriterionWeight(partialCriterion: {
  weight: number | null
  criterion: {
    defaultWeight: number
  }
}): number {
  return partialCriterion.weight ?? partialCriterion.criterion.defaultWeight
}

export function evaluateNumericalScore(
  score?: string | number,
  scale: ScorecardScale = SCALE_BINARY,
) {
  if (score === 'Not Applicable') return null

  if (scale === SCALE_5_POINT) {
    if (score === SCALE_5_POINT_0_LABEL) return SCALE_5_POINT_NM_POINTS
    if (score === SCALE_5_POINT_1_LABEL) return SCALE_5_POINT_NI_POINTS
    if (score === SCALE_5_POINT_2_LABEL) return SCALE_5_POINT_AE_POINTS
    if (score === SCALE_5_POINT_3_LABEL) return SCALE_5_POINT_ME_POINTS
    if (score === SCALE_5_POINT_4_LABEL) return SCALE_5_POINT_EE_POINTS
  }
  if (scale === SCALE_4_POINT) {
    if (score === SCALE_4_POINT__2_LABEL) return SCALE_4_POINT_NM_POINTS
    if (score === SCALE_4_POINT__1_LABEL) return SCALE_4_POINT_NI_POINTS
    if (score === SCALE_4_POINT_1_LABEL) return SCALE_4_POINT_ME_POINTS
    if (score === SCALE_4_POINT_2_LABEL) return SCALE_4_POINT_EE_POINTS
  }
  if (scale === SCALE_3_POINT) {
    if (score === SCALE_3_POINT_0_LABEL) return SCALE_3_POINT_NM_POINTS
    if (score === SCALE_3_POINT_1_LABEL) return SCALE_3_POINT_PM_POINTS
    if (score === SCALE_3_POINT_2_LABEL) return SCALE_3_POINT_ME_POINTS
  }
  if (scale === SCALE_BINARY) {
    if (score === SCALE_BINARY_MET_LABEL) return SCALE_BINARY_ME_POINTS
    if (score === SCALE_BINARY_NOT_MET_LABEL) return SCALE_BINARY_NM_POINTS
  }

  return null
}

export function scoreToLabel(score: number, scale: ScorecardScale) {
  if (scale === SCALE_5_POINT) {
    if (score === SCALE_5_POINT_NM_POINTS) return SCALE_5_POINT_0_LABEL
    if (score === SCALE_5_POINT_NI_POINTS) return SCALE_5_POINT_1_LABEL
    if (score === SCALE_5_POINT_AE_POINTS) return SCALE_5_POINT_2_LABEL
    if (score === SCALE_5_POINT_ME_POINTS) return SCALE_5_POINT_3_LABEL
    if (score === SCALE_5_POINT_EE_POINTS) return SCALE_5_POINT_4_LABEL
  }
  if (scale === SCALE_4_POINT) {
    if (score === SCALE_4_POINT_NM_POINTS) return SCALE_4_POINT__2_LABEL
    if (score === SCALE_4_POINT_NI_POINTS) return SCALE_4_POINT__1_LABEL
    if (score === SCALE_4_POINT_ME_POINTS) return SCALE_4_POINT_1_LABEL
    if (score === SCALE_4_POINT_EE_POINTS) return SCALE_4_POINT_2_LABEL
  }
  if (scale === SCALE_3_POINT) {
    if (score === SCALE_3_POINT_NM_POINTS) return SCALE_3_POINT_0_LABEL
    if (score === SCALE_3_POINT_PM_POINTS) return SCALE_3_POINT_1_LABEL
    if (score === SCALE_3_POINT_ME_POINTS) return SCALE_3_POINT_2_LABEL
  }
  if (scale === SCALE_BINARY) {
    if (score === SCALE_BINARY_ME_POINTS) return SCALE_BINARY_MET_LABEL
    if (score === SCALE_BINARY_NM_POINTS) return SCALE_BINARY_NOT_MET_LABEL
  }
  return 'Not Applicable'
}

export function toNumericalScore(
  score?: string | number,
  scale: ScorecardScale = SCALE_BINARY,
): number | null {
  if (score === 'Not Applicable') return null

  if (scale === SCALE_5_POINT) {
    if (score === SCALE_5_POINT_0_LABEL) return SCALE_5_POINT_NM_POINTS
    if (score === SCALE_5_POINT_1_LABEL) return SCALE_5_POINT_NI_POINTS
    if (score === SCALE_5_POINT_2_LABEL) return SCALE_5_POINT_AE_POINTS
    if (score === SCALE_5_POINT_3_LABEL) return SCALE_5_POINT_ME_POINTS
    if (score === SCALE_5_POINT_4_LABEL) return SCALE_5_POINT_EE_POINTS
  }
  if (scale === SCALE_4_POINT) {
    if (score === SCALE_4_POINT__2_LABEL) return SCALE_4_POINT_NM_POINTS
    if (score === SCALE_4_POINT__1_LABEL) return SCALE_4_POINT_NI_POINTS
    if (score === SCALE_4_POINT_1_LABEL) return SCALE_4_POINT_ME_POINTS
    if (score === SCALE_4_POINT_2_LABEL) return SCALE_4_POINT_ME_POINTS
  }
  if (scale === SCALE_3_POINT) {
    if (score === SCALE_3_POINT_0_LABEL) return SCALE_3_POINT_NM_POINTS
    if (score === SCALE_3_POINT_1_LABEL) return SCALE_3_POINT_PM_POINTS
    if (score === SCALE_3_POINT_2_LABEL) return SCALE_3_POINT_ME_POINTS
  }
  if (scale === SCALE_BINARY) {
    if (score === SCALE_BINARY_MET_LABEL) return SCALE_BINARY_ME_POINTS
    if (score === SCALE_BINARY_NOT_MET_LABEL) return SCALE_BINARY_NM_POINTS
  }

  return null
}

export function calculateCriterionPercentile(input: {
  scale: ScorecardScale
  points: number | null
}): number | null {
  const scaleScores = SCALE_SCORE_MAPPING[input.scale]
  if (scaleScores && input.points !== null && Object.hasOwn(scaleScores, input.points)) {
    return scaleScores[input.points as keyof typeof scaleScores]
  }
  return null
}
